import type { Testimonial } from '@/types'

import { Quote } from 'lucide-react'
import { RatingStars } from '@/components/site/rating-stars'
import { cms } from '@/lib/cms'
import { initials } from '@/lib/format'
import { cn } from '@/lib/utils'

interface TestimonialCardProps {
    testimonial: Testimonial
    className?: string
}

export const TestimonialCard = ({ testimonial, className }: TestimonialCardProps) => (
    <figure
        className={cn(
            'relative flex h-full flex-col rounded-3xl border border-border/70 bg-card p-7 shadow-[0_24px_60px_-44px_rgba(19,35,63,0.5)]',
            className
        )}
    >
        <Quote aria-hidden='true' className='absolute top-6 right-6 size-8 text-gold-200' />
        <RatingStars rating={testimonial.rating} />
        <blockquote className='mt-5 flex-1'>
            <p data-mdlfy-cms={cms('testimonials', testimonial.id, 'quote')} className='font-heading text-xl leading-snug text-navy-900'>
                {testimonial.quote}
            </p>
        </blockquote>
        <figcaption className='mt-6 flex items-center gap-3 border-t border-border/70 pt-5'>
            <span aria-hidden='true' className='flex size-11 shrink-0 items-center justify-center rounded-full bg-emerald-700 text-sm font-semibold text-cream-50'>
                {initials(testimonial.customer_name)}
            </span>
            <span className='min-w-0'>
                <span data-mdlfy-cms={cms('testimonials', testimonial.id, 'customer_name')} className='block text-sm font-semibold text-navy-900'>
                    {testimonial.customer_name}
                </span>
                <span className='block truncate text-xs text-muted-foreground'>
                    {testimonial.service_name && (
                        <span data-mdlfy-cms={cms('testimonials', testimonial.id, 'service_name')}>{testimonial.service_name}</span>
                    )}
                    {testimonial.service_name && testimonial.location && <span aria-hidden='true'>{' · '}</span>}
                    {testimonial.location && (
                        <span data-mdlfy-cms={cms('testimonials', testimonial.id, 'location')}>{testimonial.location}</span>
                    )}
                </span>
            </span>
        </figcaption>
    </figure>
)
